/**
 * Simple token counter using character-based estimation
 * For production, consider using tiktoken or similar
 */

export function estimateTokens(text: string): number {
  // Rough estimation: ~4 characters per token for English text
  // This is a simplified approximation
  const charCount = text.length;
  const wordCount = text.split(/\s+/).filter(w => w.length > 0).length;

  // Average between character-based (chars/4) and word-based (words * 1.3)
  const charBasedEstimate = charCount / 4;
  const wordBasedEstimate = wordCount * 1.3;

  return Math.round((charBasedEstimate + wordBasedEstimate) / 2);
}

export function compareTokens(json: string, toon: string): {
  jsonTokens: number;
  toonTokens: number;
  savings: number;
  savingsPercent: number;
} {
  const jsonTokens = estimateTokens(json);
  const toonTokens = estimateTokens(toon);
  const savings = jsonTokens - toonTokens;
  const savingsPercent = jsonTokens > 0 ? (savings / jsonTokens) * 100 : 0;

  return {
    jsonTokens,
    toonTokens,
    savings,
    savingsPercent
  };
}
